import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function Privacy() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-secondary)' }}>
      {/* Header */}
      <header style={{
        background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
        color: 'white',
        padding: '2rem 1.5rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '1rem' }}>
            <Logo variant="light" size="medium" />
          </div>
          <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Datenschutzerklärung
          </h1>
          <Link to="/" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', fontSize: '0.95rem' }}>
            ← Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main style={{ padding: '3rem 1.5rem' }}>
        <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ backgroundColor: 'var(--bg-primary)', borderRadius: '0.5rem', padding: '2rem', boxShadow: 'var(--shadow-md)' }}>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                1. Verantwortlicher
              </h2>
              <p>
                Verantwortlich für die Datenverarbeitung ist:
              </p>
              <p className="mt-2">
                Marcel Stelzner<br />
                c/o Online-Impressum.de 6020<br />
                Europaring 90<br />
                53757 Sankt Augustin<br />
                Deutschland<br />
                E-Mail: post@meinelisten.app
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                2. Art und Umfang der Datenverarbeitung
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-4">
                2.1 Registrierung und Anmeldung
              </h3>
              <p>Bei der Registrierung erfassen wir folgende Daten:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>E-Mail-Adresse</li>
                <li>Passwort (verschlüsselt gespeichert)</li>
                <li>Name</li>
                <li>Zeitpunkt der Registrierung und letzten Anmeldung</li>
              </ul>
              <p className="mt-2">
                Die Daten werden benötigt, um Ihnen die Nutzung der App zu ermöglichen und Ihr Benutzerkonto zu verwalten.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-4">
                2.2 E-Mail-Verifizierung
              </h3>
              <p>
                Zur Bestätigung Ihrer E-Mail-Adresse senden wir Ihnen einen Verifizierungscode. 
                Die E-Mail-Adresse wird erst nach erfolgreicher Verifizierung als bestätigt markiert.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-4">
                2.3 Einkaufslisten und Inhalte
              </h3>
              <p>Folgende Daten werden bei der Nutzung der App gespeichert:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Namen und Inhalte Ihrer Einkaufslisten</li>
                <li>Artikel mit Bezeichnung, Menge, Notizen und Kategorie</li>
                <li>Zeitstempel für Erstellung und Änderungen</li>
                <li>Informationen über geteilte Listen und Berechtigungen</li>
              </ul>
              <p className="mt-2">
                Alle Listeninhalte werden Ende-zu-Ende verschlüsselt gespeichert. 
                Nur Sie und die von Ihnen autorisierten Personen haben Zugriff auf Ihre Listen.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-4">
                2.4 Push-Benachrichtigungen
              </h3>
              <p>
                Falls Sie Push-Benachrichtigungen aktivieren, speichern wir einen 
                Push-Token (Firebase Cloud Messaging) sowie Geräteinformationen. 
                Diese Daten dienen ausschließlich dem Versand von Benachrichtigungen 
                über Änderungen in Ihren Listen.
              </p>
              <p className="mt-2">
                Sie können Push-Benachrichtigungen jederzeit in den App-Einstellungen deaktivieren.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-4">
                2.5 Einladungen
              </h3>
              <p>
                Wenn Sie andere Personen zu einer Liste einladen, speichern wir:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>E-Mail-Adresse des Eingeladenen</li>
                <li>Einladungs-Token und Status</li>
                <li>Zeitpunkt der Einladung</li>
              </ul>
              <p className="mt-2">
                Wir senden eine E-Mail an die eingeladene Person mit einem Einladungslink.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                3. Rechtsgrundlage der Verarbeitung
              </h2>
              <p>
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
                (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) 
                für optionale Funktionen wie Push-Benachrichtigungen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                4. Datenweitergabe
              </h2>
              <p>
                Wir geben Ihre Daten nicht an Dritte weiter, mit Ausnahme von:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>
                  <strong>Firebase Cloud Messaging (Google):</strong> Für Push-Benachrichtigungen. 
                  Google verarbeitet Push-Tokens gemäß ihrer Datenschutzerklärung.
                </li>
                <li>
                  <strong>E-Mail-Versand:</strong> Für Verifizierungs- und Einladungs-E-Mails 
                  nutzen wir einen E-Mail-Dienstleister.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                5. Speicherdauer
              </h2>
              <p>
                Ihre Daten werden gespeichert, solange Ihr Benutzerkonto aktiv ist. 
                Nach Löschung Ihres Kontos werden alle personenbezogenen Daten 
                einschließlich Ihrer Listen unwiderruflich gelöscht.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                6. Ihre Rechte
              </h2>
              <p>Sie haben folgende Rechte:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                <li>Widerruf Ihrer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
              </ul>
              <p className="mt-4">
                Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter: post@meinelisten.app
              </p>
              <p className="mt-2">
                Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                7. Datensicherheit
              </h2>
              <p>
                Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, 
                um Ihre Daten zu schützen:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Ende-zu-Ende-Verschlüsselung für Listeninhalte</li>
                <li>Verschlüsselte Datenübertragung (HTTPS/WSS)</li>
                <li>Passwort-Hashing mit modernen Verfahren</li>
                <li>Optionale Zwei-Faktor-Authentifizierung</li>
                <li>Regelmäßige Sicherheitsupdates</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                8. Cookies und lokaler Speicher
              </h2>
              <p>
                Die App verwendet den lokalen Speicher Ihres Browsers/Geräts für:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Authentifizierungs-Token (Session-Management)</li>
                <li>Offline-Verfügbarkeit von Daten</li>
                <li>App-Einstellungen und Präferenzen</li>
              </ul>
              <p className="mt-2">
                Diese Daten verbleiben auf Ihrem Gerät und werden nicht zu Tracking-Zwecken verwendet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                9. Änderungen dieser Datenschutzerklärung
              </h2>
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, 
                um sie an geänderte Rechtslage oder Änderungen der App anzupassen. 
                Die jeweils aktuelle Version finden Sie in der App.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        backgroundColor: 'var(--gray-800)',
        color: 'var(--gray-300)',
        padding: '2rem 1.5rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <p style={{ marginBottom: '0.5rem' }}>
            © 2026 meinelisten.app - Einkaufslisten gemeinsam verwalten
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', marginBottom: '0.5rem' }}>
            <Link 
              to="/datenschutz" 
              style={{ 
                color: 'var(--primary)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                fontWeight: '600'
              }}
            >
              Datenschutz
            </Link>
            <Link 
              to="/impressum" 
              style={{ 
                color: 'var(--gray-300)', 
                textDecoration: 'none',
                fontSize: '0.875rem'
              }}
            >
              Impressum
            </Link>
          </div>
          <p style={{ fontSize: '0.875rem', opacity: 0.8 }}>
            Made with ❤️ in Germany
          </p>
        </div>
      </footer>
    </div>
  );
}
